'use client';

import styles from './FloatingButton.module.scss';

interface FloatingButtonProps {
  label: string;
  icon: React.ReactNode;
  isLoading?: boolean;
  loadingIcon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  loadingText?: string;
}

const FloatingButton = ({
  label,
  icon,
  loadingIcon,
  isLoading = false,
  onClick,
  disabled = false,
  className = '',
  loadingText = 'Loading...',
}: FloatingButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading || disabled}
      className={`${styles.button} ${className}`}
    >
      <span>{isLoading ? loadingText : label}</span>
      <span className={styles.icon}>
        {isLoading ? loadingIcon ?? icon : icon}
      </span>
    </button>
  );
};

export default FloatingButton;